import { render, staticRenderFns } from "./EmailVerifyPopup.vue?vue&type=template&id=2a6c8194&scoped=true&"
import script from "./EmailVerifyPopup.vue?vue&type=script&lang=js&"
export * from "./EmailVerifyPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c8194",
  null
  
)

export default component.exports